angular.module('edxComponents')
  .component('edxNweaScoreRangeDropdown', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-score-range-dropdown.component.html',
    controller: ['edxNweaAssignmentService', NweaScoreRangeDropdownController],
    controllerAs: 'vm',
    bindings: {
      studentId: '<edxStudentId',
      domainId: '<edxDomainId',
      levelId: '<edxLevelId',
      onSelect: '&edxOnSelect'
    }
  });

function NweaScoreRangeDropdownController(nweaAssignmentService) {
  var vm = this;

  vm.$onChanges = $onChanges;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  vm.loading = false;
  vm.scoreRanges = [];
  vm.selected = undefined;

  var lastSentValue;

  function $onChanges(changes) {
    if (changes.domainId || changes.studentId) {
      updateScoreRanges();
      sendSelectionIfChanged(vm.selected);
    }
  }

  function updateScoreRanges() {
    if (vm.studentId && vm.domainId) {
      vm.loading = true;
      vm.selected = undefined;
      nweaAssignmentService.loadScoreRangesForStudent(vm.studentId, vm.levelId, vm.domainId).then(function (scores) {
        vm.scoreRanges = scores;
      }).catch(function () {
        vm.scoreRanges = [];
      }).finally(function () {
        vm.loading = false;
      });
    } else {
      vm.scoreRanges = [];
      vm.selected = undefined;
    }
  }

  function isDisabled() {
    return !vm.scoreRanges || vm.scoreRanges.length <= 0 || vm.loading;
  }

  function onClick(model) {
    sendSelectionIfChanged(model);
  }

  function sendSelectionIfChanged(model) {
    if (lastSentValue !== model) {
      lastSentValue = model;
      vm.onSelect({scoreRange: model});
    }
  }
}
